import React, { useEffect, useState } from 'react'

export default function useClickToClose(ref, callClose, dependecies = []){
  const checkClick = (e) => {
    if(ref.current && !ref.current.contains(e.target)){
      callClose()
    }
  }

  useEffect(() => {
    document.addEventListener('click', checkClick)
    return () => {
      document.removeEventListener('click', checkClick)
    }
  }, dependecies)
}